"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisabledMortgageInputFields = exports.RequiredMortgageFields = exports.DefaultMortgageData = void 0;
var DefaultMortgageData = function () {
    return {
        id: Date.now(),
        name: '',
        min_prepayment: '',
        min_percent: '',
        max_duration: 240,
        is_exclusive: 'no',
        mortgage_programs: [],
    };
};
exports.DefaultMortgageData = DefaultMortgageData;
exports.RequiredMortgageFields = [
    'name',
    'min_prepayment',
    'min_percent',
    'max_duration',
];
exports.DisabledMortgageInputFields = [
    'is_exclusive',
    'min_prepayment',
    'min_percent',
    'max_duration',
    'mortgage_programs',
];
